import styled from "@emotion/styled";
import { InputLabel } from "@mui/material";
import { LinkButton } from "components/Buttons";

export const LnkButton = styled(LinkButton)(({ theme }) => ({
  color: theme.palette.primary.darkBlue70,
  height: '50px',
  minWidth: 'fit-content',
}));

export const fieldContainer = {
  paddingTop: '25px',
  width: '300px',
  position: 'relative',
  '& .MuiInputBase-input': {
    paddingRight: '40px !important',
  },
};

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  fontSize: '14px',
  marginBottom: '8px',
  color: theme.palette.primary.gray75,
}));

export const checkboxContainer = {
  backgroundColor: 'transparent',
  border: '0px',
  '& .MuiFormControlLabel-root': {
    alignItems: 'start',
    '& .MuiCheckbox-root': {
      padding: '0px',
      '& span': {
        width: '20px',
        height: '20px',
      },
      '& svg': {
        width: '20px',
        height: '20px',
      },
    },
  },
};

